import { notificationsConfig } from '@infotech/mapissues'
import { agreementNotificaions } from '@infotech/agreement'

export default {
  ...notificationsConfig,
  notifications: [
    ...notificationsConfig.notifications,
    ...agreementNotificaions,
  ],
}